module.exports = __webpack_public_path__ + "img/Add-icon.7695a361.svg";